<h2 mat-dialog-title class="flex justify-between items-center mt-3">
  <span class="block">{{ recipe.name() }} {{ message('recipeSuffix') }}</span>
  <span class="material-icons cursor-pointer hover:opacity-80" (click)="close()">close</span>
</h2>
<mat-dialog-content class="grid grid-cols-5 gap-4 min-w-[40vw]">
  <div class="col-start-2 col-span-1 font-medium text-center">
    {{ message('nameLabel') }}
  </div>
  <div class="col-start-4 col-span-1 flex items-center justify-center font-medium">
    {{ message('adjustedLabel') }}
    <button class="material-icons cursor-help hover:opacity-80 text-[22px] translate-y-[-1px] pl-1"
            [matTooltip]="message('adjustedTooltip')">
      help_outline
    </button>
  </div>
  <div class="col-span-1 flex items-center justify-center font-medium">
    {{ message('baseLabel') }}
    <button class="material-icons cursor-help hover:opacity-80 text-[22px] translate-y-[-1px] pl-1"
            [matTooltip]="message('baseTooltip')">
      help_outline
    </button>
  </div>
  <div class="col-span-1 flex items-center ml-auto">
    <span class="font-medium">{{ message('craftingTableLabel') }}</span>
  </div>
  <div class="col-span-4 flex items-center rounded p-2 recipe-detail-container">
    <img [src]="imageService.imageTemplateUrl" width="32" height="32"
         [style]="imageService.getTableImgStyle(recipe.craftingTable)" [alt]="recipe.craftingTable.name() + ' Icon'"
         class="mr-2">
    <span>{{ recipe.craftingTable.name() }}</span>
  </div>
  <div class="col-span-1 flex items-center ml-auto">
    <span class="font-medium">{{ message('skillLabel') }}</span>
  </div>
  <div class="col-span-4 grid grid-cols-4 gap-4 rounded p-2 recipe-detail-container">
    <div class="col-span-2 flex items-center">
      <img [src]="imageService.imageTemplateUrl" width="32" height="32"
           [style]="imageService.getSkillImgStyle(recipe.skill)" [alt]="recipe.skill.name() + ' Icon'"
           class="mr-2">
      <span>{{ recipe.skill.name() }}</span>
    </div>
    <div class="col-start-4 col-span-1 flex items-center justify-center">
      <span class="readonly-field w-24">{{ recipe.level }}</span>
    </div>
  </div>
  <div class="col-span-1 flex items-center ml-auto">
    <span class="font-medium">{{ message('laborLabel') }}</span>
  </div>
  <div class="col-span-4 grid grid-cols-4 gap-4 rounded p-2 recipe-detail-container">
    <div class="col-span-2 flex items-center">
      <img [src]="imageService.imageTemplateUrl" width="32" height="32"
           [style]="imageService.getCalorieImgStyle()" alt="Labor Icon" class="mr-2">
      <span>{{ message('Calories') }}</span>
    </div>
    <div class="col-start-3 col-span-1 flex items-center justify-center">
      <span
        class="readonly-field w-24">{{ craftingService.computeAdjustedLabor(recipe) | localeNumber:localeCode() }}</span>
    </div>
    <div class="col-start-4 col-span-1 flex items-center justify-center">
      <span class="readonly-field w-24">{{ recipe.labor }}</span>
    </div>
  </div>
  <div class="col-span-1 flex items-center ml-auto">
    <span class="font-medium">{{ message('ingredientsHeader') }}</span>
  </div>
  <div class="col-span-4 grid grid-cols-4 gap-4 rounded p-2 recipe-detail-container">
    @for (input of recipe.ingredients; track input.item.nameID) {
      <div class="col-span-2 flex items-center">
        <img [src]="imageService.imageTemplateUrl" width="32" height="32"
             [style]="imageService.getItemImgStyle(input.item)" [alt]="input.item.name() + ' Icon'"
             [class]="input.reducible ? 'reducible-item' : 'static-item'">
        <span class="ml-2">{{ input.item.name() }}</span>
      </div>
      <div class="col-start-3 col-span-1 flex items-center justify-center">
        <span
          class="readonly-field w-24">{{ craftingService.computeAdjustedInputQuantity(recipe, input) | localeNumber:localeCode() }}</span>
      </div>
      <div class="col-start-4 col-span-1 flex items-center justify-center">
        <span class="readonly-field w-24">{{ input.quantity }}</span>
      </div>
    }
  </div>
  <div class="col-span-1 flex items-center ml-auto">
    <span class="font-medium">{{ message('outputsHeader') }}</span>
  </div>
  <div class="col-span-4 grid grid-cols-4 gap-4 rounded p-2 recipe-detail-container">
    @for (output of recipe.outputs; track output.item.nameID) {
      <div class="col-span-2 flex items-center">
        <img [src]="imageService.imageTemplateUrl" width="32" height="32"
             [style]="imageService.getItemImgStyle(output.item)" [alt]="output.item.name() + ' Icon'"
             [class]="output.reducible ? 'reducible-item' : ''">
        <span class="ml-2">{{ output.item.name() }}</span>
        @if (output.primary) {
          <span class="text-xs pl-1">{{ message('primaryLabel') }}</span>
        }
      </div>
      <div class="col-start-3 col-span-1 flex items-center justify-center">
        <span
          class="readonly-field w-24">{{ craftingService.computeAdjustedOutputQuantity(recipe, output) | localeNumber:localeCode() }}</span>
      </div>
      <div class="col-start-4 col-span-1 flex items-center justify-center">
        <span class="readonly-field w-24">{{ output.quantity }}</span>
      </div>
    }
  </div>
</mat-dialog-content>
